// @ts-nocheck
module.exports = {
    br: require('./br.json'),
    us: require('./us.json')
};
